module.exports = __webpack_public_path__ + "static/media/angular-logo.ff389531.png";